import React from 'react';
import {RiRobot3Line} from "react-icons/ri";
import classNames from "classnames";
import {BsCopy} from "react-icons/bs";
import {useAI} from "../hooks/useAI";


export function CourseContextMenu({show, x, y, explanationCallback}) {

    const {addMessage, messages} = useAI();


    const listItemClass = classNames("border-bottom py-2 px-3 clickable context-menu-item")


    const handleCopy = () => {
        const textToCopy = window.getSelection().toString();
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                console.log('Copied to clipboard');
            })
            .catch((err) => {
                console.error('Failed to copy:', err);
            });
    };


    function explainSelectedContent() {
        const selection = window.getSelection().toString();
        addMessage({type: "USER", content: selection, contentType: "FORKLAR"})
        if(explanationCallback != null) {
            explanationCallback(true)
        }
    }

    if (show) {
        return (
            <div className={"rounded bg-white border p-0 shadow "} style={{
                position: 'absolute',
                top: y,
                left: x,
                zIndex: 1000,
                userSelect: 'none',
                cursor: 'pointer'
            }}>
                <ul className={"m-0 p-0 w-100"}
                    style={{listStyle: "none"}}
                >
                    <li className={listItemClass}  onClick={() => explainSelectedContent()}>
                        <RiRobot3Line size={18} className={"me-2 clickable"}/>
                        <label className={"clickable"}>Forklar med KI</label>
                    </li>
                    <li className={listItemClass} onClick={() => handleCopy()}>
                        <BsCopy size={18} className={"me-2 clickable"}/>
                        <label className={"clickable"}>Kopier</label>
                    </li>
                </ul>
            </div>
        );
    }

}